import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import { assignableRoles, canManageUser, roleLabel, rowNote } from '../../common/auth/roles';

export default function RoleCell({ row, actorRole, onChange, disabled }) {
  if (!canManageUser(actorRole, row)) {
    const label = <span>{roleLabel(row.role)}</span>;
    const note = rowNote(actorRole, row);
    return note ? <Tooltip title={note}>{label}</Tooltip> : label;
  }

  const options = assignableRoles(actorRole);

  return (
    <Select
      size="small"
      variant="standard"
      value={row.role}
      disabled={disabled}
      onChange={(e) => e.target.value !== row.role && onChange(e.target.value)}
      onClick={(e) => e.stopPropagation()}
    >
      {options.map((role) => (
        <MenuItem key={role} value={role}>{roleLabel(role)}</MenuItem>
      ))}
    </Select>
  );
}
